import type { BaseEntity } from './BaseEntity';

export interface AuthRole extends BaseEntity {
  name: string;
  hierarchy: AuthRole[];
}

export enum RoleName {
  SuperAdmin = 'Super Admin',
  User = 'User',
  SalesPartner = 'Sales Partner',
  InstallPartner = 'Install Partner',
  LocationAdmin = 'Location Admin',
  OrgAdmin = 'Org Admin',
}

export interface AuthRolesRes {
  superAdmin: number;
  orgAdmin: number;
  locationAdmin: number;
  user: number;
  total: number;
  pending: number;
}
